<!-- eslint-disable -->
<template>
  <v-app>       
    <v-navigation-drawer 
      v-if="oidcUser"
      v-model="drawer" 
      mobile-break-point="1023"
      class="secondary no-print"
      app>
      <v-toolbar flat color="primary">
        <v-list class="pa-1">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title v-if="oidcUser">{{ oidcUser.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>      
      <v-list
        class="pt-0"
        dense>
        <v-divider light></v-divider>
        <v-list-tile 
          @click.stop="title = 'Home'"
          :to="'/'">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile>
        <v-list-tile 
          @click.stop="title = 'Database'"
          :to="'/database'">
          <v-list-tile-action>
            <v-icon>access_time</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Database</v-list-tile-title>
        </v-list-tile>

        <v-list-tile 
          @click.stop="title = 'Analytics'"
          :to="'/analytics'">
          <v-list-tile-action>
            <v-icon>access_time</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Analytics</v-list-tile-title>
        </v-list-tile>
        <v-divider light></v-divider>
        <v-list-tile @click.stop="signOutOidc">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Uitloggen</v-list-tile-title>
        </v-list-tile>
        <v-divider light></v-divider>
        <v-list-tile to="/about">
          <v-list-tile-title class="text-xs-right font-weight-thin">versie 1.1</v-list-tile-title>
        </v-list-tile>       
      </v-list>
    </v-navigation-drawer>      
    <v-toolbar  
      v-if="oidcUser"
      fixed 
      app 
      color="primary"
      class="no-print"
      :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-toolbar>      
    <v-content>
      <v-container>
        <router-view  v-if="oidcUser || $route.meta.isOidcCallback"></router-view>
        <v-layout v-if="!oidcUser">
          <v-flex>
            <h1>Inloggen</h1>
            De sessie is verlopen, klik <v-btn small color="primary" @click="reloadWindow">hier</v-btn> om opnieuw in te loggen
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<style scoped>
  .v-list__tile--active { color: lime }
</style>
<style>
  @media screen {
    table.v-table tbody td, table.v-table tbody td:not(:nth-child(1)), table.v-table tbody td:first-child { padding: 0 0 0 8px; }
  }
  @media print {
    * { color: black }
    .application-wrap, .v-content__wrap { flex: 0 !important }
    .container { padding: 0 !important }
    .theme--dark.application, .theme--dark.v-table, .theme--dark.v-table thead th, .theme--dark.v-table tbody tr:hover:not(.v-datatable__expand-row)  { background: white !important; color: black !important; }
    div[role=listitem] { border-bottom: 1px solid black !important; }
    div[role=listitem].primary {
      border-top: 2px solid black !important;
      background-color: black !important;
      font-weight: bold !important;
      color: white !important;
    }
    .no-print { display: none }
    table.v-table tbody td.success { color: white !important }
    table.v-table tbody td.grey { color: white !important }
    table.v-table tbody td.extra { border: 2px solid yellow !important }
    button { display: none !important }
    .v-content { padding: 0 !important }
    table.v-table { width: auto !important }
    table.v-table tbody td, table.v-table thead th { font-weight: bold !important }
    table.v-table tbody td:not(.extra), table.v-table thead th { border: 1px solid black !important }
    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) { padding: 4px !important }
  }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      title: 'Home',
      drawer: null,
      clipped: false,
    }
  },
  computed: {
    ...mapGetters([
      'oidcUser',
      'oidcAccessTokenExp'
    ]),
  },
  methods: {
    ...mapActions([
      'signOutOidc',
      'authenticateOidcSilent'
    ]),
    reloadWindow() {
      window.location.reload()
    },
  },
  mounted () {
    window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
  },
  destroyed () {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
  }
}
</script>